"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _lodash = _interopRequireDefault(require("lodash"));
var _strings = require("../common_features/utility/strings");
var _reactRouterDom = require("react-router-dom");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _WaterDestinationComponent = _interopRequireDefault(require("../components/WaterDestinationComponent"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _helper = require("../common_features/utility/helper");
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditWaterDestination = () => {
  const [openWaterModal, setOpenWaterModal] = (0, _react.useState)(false);
  const [shouldCheckBoxDisabled, setShouldCheckBoxDisabled] = (0, _react.useState)(false);
  const {
    selectedSystems,
    selectedWaterDest
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [initialSelectedItem, setInitialSelectedItems] = (0, _react.useState)({});
  const [selectedItems, setSelectedItems] = (0, _react.useState)(selectedWaterDest);
  const dispatch = (0, _reactRedux.useDispatch)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(() => {
    let obj = {};
    for (let si of _strings.items) {
      obj[si.name] = false;
    }
    for (let item of selectedSystems.waterDest) {
      obj[item.name] = true;
    }
    if (_lodash.default.isEmpty(selectedWaterDest)) {
      setSelectedItems({
        ...obj
      });
    } else {
      setSelectedItems(selectedWaterDest);
    }
    setInitialSelectedItems({
      ...obj
    });
  }, []);
  (0, _react.useEffect)(() => {
    const myArr = [];
    for (let item of Object.keys(selectedItems)) {
      if (selectedItems[item]) {
        myArr.push(item);
      }
    }
    myArr.length === 4 ? setShouldCheckBoxDisabled(true) : setShouldCheckBoxDisabled(false);
  }, [selectedItems]);
  const handleBack = () => {
    navigate(-1);
  };
  const handleDestinationSelection = (key, value) => {
    let obj = {
      ...selectedItems
    };
    obj[key] = value;
    setSelectedItems({
      ...obj
    });
  };
  const handleWaterModal = modal => {
    setOpenWaterModal(modal);
  };
  const handleSave = () => {
    const myArray = [];
    for (let item of Object.keys(selectedItems)) {
      if (selectedItems[item]) {
        myArray.push({
          name: item
        });
      }
    }
    dispatch((0, _systemsReducer.setSelectedWaterDest)(selectedItems));
    navigate(_RoutePath.default.addNotes.useLink, {
      state: {
        changesFlag: !_lodash.default.isEqual(selectedItems, initialSelectedItem),
        serviceLogType: _helper.SERVICE_LOGS_TYPE.WATER_DEST_UPDATED,
        successModalTitle: "Water Destination Updated",
        successModalDetail: "Water destination has been updated successfully.",
        payload: {
          waterDest: myArray
        }
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_WaterDestinationComponent.default, {
    navHeading: "System Dashboard",
    rightNavHeading: "Cancel",
    handleCancle: handleBack,
    headerText: "Where is the water going?",
    pumpSetupContent: "Please select a water destination for your system.",
    handleWaterModal: handleWaterModal,
    openWaterModal: openWaterModal,
    aboutWaterContent: "About water Destination",
    items: _strings.items,
    selectedItems: selectedItems,
    handleCheckBoxSelection: handleDestinationSelection,
    pumpSetupBottomContent: "Minimum 1 water destination.",
    saveContinueBtnClick: handleSave,
    saveContinueBtnTitle: "Continue",
    saveContinueBtnDisabled: selectedItems.Hot || selectedItems.Ice || selectedItems.Steam || selectedItems.Fountain ? false : true,
    shouldCheckBoxDisabled: shouldCheckBoxDisabled,
    modalHeaderText: "About Water Destinations",
    positiveActionButtonTitle: "Ok",
    imageData: _strings.imageData,
    handleBack: handleBack,
    leftArrow: _images.default.leftArrow.default,
    backNavigationScreen: "System Dashboard"
  });
};
var _default = exports.default = EditWaterDestination;